import { render } from "./WhoWeAre.vue?vue&type=template&id=4ba204c2"
import script from "./WhoWeAre.vue?vue&type=script&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__